import { render } from "./CRMDatatableTDTaskCheckbox.vue?vue&type=template&id=658ede48"
import script from "./CRMDatatableTDTaskCheckbox.vue?vue&type=script&lang=js"
export * from "./CRMDatatableTDTaskCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__